module.exports = __webpack_public_path__ + "static/closeIcon.7b3f5ff9.svg";